// extracted by mini-css-extract-plugin
export default {"cls1":"ggxgXykMuGPC0YzblX1k","cls2":"nbHRzXVWofsdTnK4Blq1 ggxgXykMuGPC0YzblX1k"};